import { inject, NgZone } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';

const noTokenUrls = [
  '/api/v1/auth/login',
];

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const ngZone = inject(NgZone);
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && !(noTokenUrls.some((url) => req.url.includes(url)) || req.url.includes('/api/v1/auth/refresh-token'))) {
        return throwError(() => err);
      }

      ngZone.run(() => {
        messageService.add({
          severity: 'error',
          summary: err.error.title,
          detail: err.error.detail,
          closable: false,
        });
      });

      return throwError(() => err);
    }),
  );
};
